import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button, Typography } from '@mui/material';
import { CommunityFilter } from '../model/CommunityFilter';
import { IOSSlider } from './IOSSlider';
import { useChangeDistance } from '../hook/useFilterAction';
import { PlaceData } from '../model/Places';

type FilterLocationProps = {
  changeLocation: () => void;
  communityFilter: CommunityFilter;
};

const MARKS = [
  {
    value: 0,
    label: '5',
  },
  {
    value: 10,
    label: '',
  },
  {
    value: 20,
    label: '',
  },
  {
    value: 30,
    label: '',
  },
  {
    value: 40,
    label: '',
  },
  {
    value: 50,
    label: '',
  },
  {
    value: 60,
    label: '',
  },
  {
    value: 70,
    label: '',
  },
  {
    value: 80,
    label: '',
  },
  {
    value: 90,
    label: '',
  },
  {
    value: 100,
    label: '100',
  },
];

export const DistanceFilter = ({
  changeLocation,
  communityFilter,
}: FilterLocationProps) => {
  const intl = useIntl();
  const changeDistance = useChangeDistance();

  return (
    <Box sx={{ py: 5, px: 10 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ fontWeight: 500 }}>
          <FormattedMessage id='community.filter.distance-from' />
        </Typography>
        <Button variant='text' onClick={changeLocation}>
          <Typography sx={{ fontWeight: 500, textDecoration: 'underline' }}>
            {showLocation(communityFilter.locationData)}
          </Typography>
        </Button>
      </Box>
      <Box sx={{ mt: 16, mb: 8 }}>
        <IOSSlider
          value={communityFilter.distanceInMiles}
          onChange={changeDistance}
          aria-label='Default'
          valueLabelDisplay='on'
          min={0}
          max={100}
          marks={MARKS}
          valueLabelFormat={(value) =>
            intl.formatMessage(
              { id: 'community.filter.miles' },
              { distance: value < 10 ? 5 : Math.round(value / 10) * 10 },
            )
          }
        />
      </Box>
    </Box>
  );
};

const showLocation = (locationData: PlaceData | null) =>
  locationData
    ? [locationData.city, locationData.state].filter((val) => !!val).join(', ')
    : '';
